// angular
import { CommonModule } from '@angular/common';
import { Component, inject, input, OnChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'pwj-pagination',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './pagination.component.html',
  styleUrl: './pagination.component.scss',
})
export class PaginationComponent implements OnChanges {
  public pages: number = 0;
  public currentPage: number = 1;
  public paginatedData!: any;
  public firstSliceOfPages!: number[];
  public secondSliceOfPages!: number[];

  // inputs
  data = input<[] | null>(null);
  dataCount = input.required<number>();
  perPage = input<number>(4);

  // dependencies
  private readonly _router = inject(Router);
  private readonly _activatedRoute = inject(ActivatedRoute);

  constructor() {
    this._activatedRoute.queryParams.subscribe(params => {
      this.currentPage = params?.['page'] ? Number(params?.['page']) : 1;
    });
  }

  ngOnChanges(): void {
    if (this.dataCount) {
      this.pages = Math.ceil(this.dataCount() / this.perPage());
    }

    // if (this.data && this.data !== null) {
    //   this.pages = Math.ceil((this.data() as [])?.length / this.perPage());
    // }
  }

  public getVisiblePages(): number[] {
    const totalPages = this.pages;
    const visiblePages = 5;
    const currentPage = this.currentPage;
    const halfVisiblePages = Math.floor(visiblePages / 2);
    let startPage: number;
    let endPage: number;

    if (totalPages <= visiblePages) {
      // if total pages are less than or equal to visible pages, show all pages
      startPage = 1;
      endPage = totalPages;
    } else if (currentPage - halfVisiblePages <= 0) {
      // if current page is close to the beginning
      startPage = 1;
      endPage = visiblePages;
    } else if (currentPage + halfVisiblePages >= totalPages) {
      // if current page is close to the end
      startPage = totalPages - visiblePages + 1;
      endPage = totalPages;
    } else {
      // if current page is somewhere in the middle
      startPage = currentPage - halfVisiblePages;
      endPage = currentPage + halfVisiblePages;
      // adjust startPage and endPage if needed to ensure consecutive visible pages
      if (endPage - startPage + 1 < visiblePages) {
        endPage = startPage + visiblePages - 1;
      }
    }

    return Array.from(
      { length: endPage - startPage + 1 },
      (_, i) => startPage + i
    );
  }

  public setCurrentPage(pageIndex: number) {
    this.currentPage = pageIndex;
    this.setParams(this.currentPage);
  }

  // this method is for slice data and we do not need that at this moment so i commented this code

  // public paginateOnData() {
  //   if (this.currentPage === 1) {
  //     this.paginatedData = this.data.slice(0, this.perPage);
  //   } else {
  //     const startSlice = (this.currentPage - 1) * this.perPage;
  //     const endSlice = startSlice * 2;
  //     this.paginatedData = this.data.slice(startSlice, endSlice);

  //     if (this.paginatedData.length < this.perPage) {
  //       for (let i = this.paginatedData.length; i < this.perPage; i++) {
  //         this.paginatedData = [
  //           this.data[this.data.length - (i + 1)],
  //           ...this.paginatedData,
  //         ];
  //       }
  //     }
  //   }
  // }

  public navigateToPrevPage() {
    if (this.currentPage > 1) {
      this.currentPage = --this.currentPage;
      this.setParams(this.currentPage);
    }
  }

  public navigateToNextPage() {
    if (this.currentPage < this.pages) {
      this.currentPage = ++this.currentPage;
      this.setParams(this.currentPage);
    }
  }

  public setParams(page: number) {
    this._router.navigate([], {
      queryParams: {
        page,
        perPage: this.perPage(),
      },
      queryParamsHandling: 'merge',
    });
  }
}
